import { saveUserData } from './saveUserData'
import { getTrackedId, type SaveMultipleUserDataProps } from './utils'

export const saveMultipleUserData = ({
  key,
  ids,
  actionType,
  eventName,
}: SaveMultipleUserDataProps) => {
  ids?.forEach((id) => {
    saveUserData({
      key,
      id: getTrackedId({ key, id }),
      actionType,
      eventName,
    })
  })
}
